<template>
  <div class="comment-item" :class="{ deleted: value.is_deleted }">
    <div class="main">
      <div class="box-header">
        <bean-link
          v-if=" value.creator_type === 'User'"
          target="_blank"
          :to="{ name: 'users.show', params: { id:  $get(value, 'creator_id') } }"
          keepNode
        >
          <div class="name">{{ $get(value, 'creator.screen_name') }}</div>
        </bean-link>
        <span v-else>管理员</span>
        <div class="btn-group">
          <el-button v-if="!value.root_id" size="mini" :loading="loading.top" @click="handleToogleTop">{{ value.is_top ? '取消置顶' : '置顶' }}</el-button>
          <el-button size="mini" :loading="loading.hide" @click="handleToogleHidden">{{ value.is_deleted ? '显示' : '隐藏' }}</el-button>
          <!-- <el-button size="mini" :loading="loading.read" @click="handleSetReaded" v-if="!value.admin_read">设为已读</el-button> -->
        </div>
      </div>
      <div class="comment-desc">
        <div class="reply-to" v-if="value.parent && value.parent_id !== value.root_id">
          回复 <bean-link target="_blank" :to="{ name: 'users.show', params: { id: $get(value, 'parent.creator.id') } }" class="reply-to-name text-overflow">{{ $get(value, 'parent.creator.screen_name') }}</bean-link> :
        </div>
        <div class="comment-content">{{ value.content }}</div>
      </div>
      <div class="comment-footer">
        <div class="options">
          <div class="option" v-if="!value.root_id">
            <img class="option-comment option-icon" :src="require('@/assets/icon-comment.png')"/>
            <span class="count">{{ $get(value, 'commentable_comment_datum.comments_count') }}</span>
          </div>
          <div class="option">
            <img class="option-icon" :src="require('@/assets/icon-like.png')"/>
            <span class="count">{{ value.likes_count }}</span>
          </div>
        </div>
         <div class="date">{{ createdAt }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Vue, Component, Model } from 'vue-property-decorator';
import moment from 'moment';
import _ from 'lodash';

@Component
export default class CommentItem extends Vue {
  @Model('change', { type: Object, default: () => ({}) }) value;

  loading = {
    top: false,
    hide: false,
    read: false
  };
  $get = _.get;

  get createdAt() {
    return moment(this.value.created_at).format('YYYY-MM-DD HH:mm:ss');
  }

  async handleToogleTop() {
    this.loading.top = true;
    try {
      await this.$request.put(`/comments/${this.value.id}/${this.value.is_top ? 'position_to_nil' : 'position_to_minimum'}`)
      this.$emit('change', { ...this.value, is_top: !this.value.is_top });
    } finally {
      this.loading.top = false;
    }
  }

  async handleToogleHidden() {
    this.loading.hide = true;
    try {
      await this.$request.put(`/comments/${this.value.id}/${this.value.is_deleted ? 'show' : 'hide'}`)
      this.$emit('change', { ...this.value, is_deleted: !this.value.is_deleted });
    } finally {
      this.loading.hide = false;
    }
  }

  async handleSetReaded() {
    this.loading.read = true;
    try {
      await this.$request.post('/normal_comments/batch_read', { id_in: [this.value.id] });
      this.$emit('change', { ...this.value, admin_read: true });
    } finally {
      this.loading.read = false;
    }
  }
}
</script>

<style lang="scss" scoped>

  .deleted {
    opacity: .5;
  }

  .main {
    .box-header {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .name {
        font-size: 12px;
        color: #666;
      }
    }

    .comment-content {
      white-space: pre-line;
    }

    .comment-desc {
      margin-top: 12px;
      font-size: 13px;
      line-height: 20px;
      color: #000;

      .reply-to {
        display: flex;
        margin-bottom: 8px;
        font-size: 11px;

        .reply-to-name {
          max-width: 200px;
          color: #666;
        }
      }
    }
  }

  .response {
    padding: 15px;
    margin-top: 20px;
    background: #f2f2f2;

    .response-item {
      font-size: 12px;
    }

    .response-item + .response-item,
    .total {
      margin-top: 8px;
    }

    .res-name,
    .total {
      font-size: 12px;
      color: #4abce5;
    }
  }

  .comment-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 8px;

    .date {
      font-size: 11px;
      color: #999;
    }

    .options {
      display: flex;
      align-items: center;
    }

    .option {
      display: flex;
      align-items: center;
      position: relative;
      margin-right: 10px;
      font-size: 12px;
    }

    // 评论图标看起来像是没有对齐
    .option-comment {
      margin-bottom: -3px;
    }

    .option-icon {
      width: 15px;
      height: 15px;
      margin-right: 3px;
    }

    .count {
      color: #666;
    }
  }
</style>
